/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsContactAdministratorRoute } from '@jira/router-routes__admin-pages-contact-administrator-routes/src/globalSettingsContactAdministratorRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ContactAdministratorPage, { LazyContactAdministratorPage } from './ui/index.tsx';

export const globalSettingsContactAdministratorRouteEntry: Route = createEntry(
	globalSettingsContactAdministratorRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.contact-administrator',
		// eslint-disable-next-line no-restricted-syntax
		component: ContactAdministratorPage,
		layout: globalLayout,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyContactAdministratorPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
